import {
  telephonyFeatures,
  telephonyProviders,
} from "@/src/constants/telephonyConstants";

class ProviderFeatureManager {
  constructor() {
    const plivoFeatures = {
      [telephonyFeatures.callOutbound]: { available: true },
      [telephonyFeatures.callInbound]: { available: true },
      [telephonyFeatures.powerDialer]: { available: true },
      [telephonyFeatures.parallelDialer]: { available: false },
      [telephonyFeatures.callForwarding]: { available: true },
      [telephonyFeatures.callRouting]: { available: true },
      [telephonyFeatures.coldTransfer]: { available: false },
      [telephonyFeatures.warmTransfer]: { available: false },
      [telephonyFeatures.voicemails]: { available: false },
      [telephonyFeatures.callRecording]: { available: true },
      [telephonyFeatures.callTranscript]: { available: true },
      [telephonyFeatures.callSwap]: { available: false },
      [telephonyFeatures.purchasePhoneNumber]: { available: true },
      [telephonyFeatures.deletePhoneNumber]: { available: true },
      [telephonyFeatures.callMute]: { available: true },
      [telephonyFeatures.callHold]: { available: true },
      [telephonyFeatures.callDialer]: { available: true },
      [telephonyFeatures.callNote]: { available: true },
      [telephonyFeatures.voicemailDrop]: { available: false },
    };

    const retellFeatures = {
      [telephonyFeatures.callOutbound]: { available: true },
      [telephonyFeatures.callInbound]: { available: false },
      [telephonyFeatures.powerDialer]: { available: false },
      [telephonyFeatures.parallelDialer]: { available: false },
      [telephonyFeatures.callForwarding]: { available: false },
      [telephonyFeatures.callRouting]: { available: false },
      [telephonyFeatures.coldTransfer]: { available: false },
      [telephonyFeatures.warmTransfer]: { available: false },
      [telephonyFeatures.voicemails]: { available: false },
      [telephonyFeatures.callRecording]: { available: false },
      [telephonyFeatures.callTranscript]: { available: true },
      [telephonyFeatures.callSwap]: { available: false },
      [telephonyFeatures.purchasePhoneNumber]: { available: false },
      [telephonyFeatures.deletePhoneNumber]: { available: false },
      [telephonyFeatures.callMute]: { available: false },
      [telephonyFeatures.callHold]: { available: false },
      [telephonyFeatures.callDialer]: { available: false },
      [telephonyFeatures.callNote]: { available: false },
    };

    this.providerFeatures = {
      [telephonyProviders.twilio]: {
        [telephonyFeatures.callOutbound]: { available: true },
        [telephonyFeatures.callInbound]: { available: true },
        [telephonyFeatures.powerDialer]: { available: true },
        [telephonyFeatures.parallelDialer]: { available: true },
        [telephonyFeatures.callForwarding]: { available: true },
        [telephonyFeatures.callRouting]: { available: true },
        [telephonyFeatures.coldTransfer]: { available: true },
        [telephonyFeatures.warmTransfer]: { available: true },
        [telephonyFeatures.voicemails]: { available: true },
        [telephonyFeatures.callRecording]: { available: true },
        [telephonyFeatures.callTranscript]: { available: true },
        [telephonyFeatures.callSwap]: { available: true },
        [telephonyFeatures.purchasePhoneNumber]: { available: true },
        [telephonyFeatures.deletePhoneNumber]: { available: true },
        [telephonyFeatures.callMute]: { available: true },
        [telephonyFeatures.callHold]: { available: true },
        [telephonyFeatures.callDialer]: { available: true },
        [telephonyFeatures.callNote]: { available: true },
        [telephonyFeatures.voicemailDrop]: { available: true },
      },
      [telephonyProviders.plivo]: plivoFeatures,
      [telephonyProviders.plivoInternational]: plivoFeatures,
      [telephonyProviders.retell]: retellFeatures,
    };
  }

  isFeatureAvailable(provider, feature) {
    return this.providerFeatures[provider]?.[feature]?.available || false;
  }

  getUnavailableFeatures(provider) {
    const features = this.providerFeatures[provider] || {};
    return Object.keys(features).filter(
      (feature) => !features[feature].available,
    );
  }

  validateFeatureSupport(provider, feature) {
    if (!this.isFeatureAvailable(provider, feature)) {
      throw new Error(
        `Feature '${feature}' is not available for provider '${provider}'`,
      );
    }
  }

  getAllAvailableFeatures(provider) {
    const features = this.providerFeatures[provider] || {};
    return Object.keys(features).filter(
      (feature) => features[feature].available,
    );
  }

  getFeatureStatus(provider) {
    const features = this.providerFeatures[provider] || {};
    const available = Object.keys(features).filter(
      (feature) => features[feature].available,
    );
    const unavailable = Object.keys(features).filter(
      (feature) => !features[feature].available,
    );

    return {
      total: Object.keys(features).length,
      available: available.length,
      unavailable: unavailable.length,
      availableFeatures: available,
      unavailableFeatures: unavailable,
    };
  }

  isParallelDialerSupported(provider) {
    if (provider === telephonyProviders.plivo || provider === telephonyProviders.plivoInternational) {
      try {
        return !!localStorage.getItem("plivo_parallel");
      } catch (error) {
        console.error("Error checking plivo parallel feature toggle:", error);
        return false;
      }
    }
    return this.isFeatureAvailable(provider, telephonyFeatures.parallelDialer);
  }
}

export default new ProviderFeatureManager();
